import { render, staticRenderFns } from "./CreateALF.vue?vue&type=template&id=8905c1be"
import script from "./CreateALF.vue?vue&type=script&lang=js"
export * from "./CreateALF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports